import { actions } from './actions';
import { getters } from './getters';
import { mutations } from './mutations';
import { ScriveWorkflowJobState, ScriveSignersTabModel } from '@/types';

export const state: ScriveWorkflowJobState = {
  scriveSignersTab: {} as ScriveSignersTabModel,
  isScriveSignersTabLoading: true,
  isLoading: false,
  error: false,
  errorMessage: ''
};

const namespaced: boolean = true;

export const scriveWorklowJob = {
  namespaced,
  state,
  actions,
  getters,
  mutations
};
